/* card-swatches.js — click a collection-card colour dot to swap the card image in place (replaces Color Swatch King) */
(function () {
  if (window.__lumCardSwatch) return;
  window.__lumCardSwatch = true;

  function swapImage(card, url) {
    if (!card || !url) return;
    var img = card.querySelector('.card__media img, .card__inner img, .media img, img');
    if (!img) return;
    var pic = img.closest('picture');
    if (pic) {
      var sources = pic.querySelectorAll('source');
      for (var i = 0; i < sources.length; i++) sources[i].srcset = url;
    }
    img.srcset = url;
    img.src = url;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.card-swatch-btn') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('.card-swatches');
    var card = btn.closest('.card-wrapper') || btn.closest('.card') || btn.closest('.grid__item');
    var url = btn.getAttribute('data-img');
    var vid = btn.getAttribute('data-variant');
    if (url) swapImage(card, url);
    if (vid && card) {
      var links = card.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) {
        var base = (links[i].getAttribute('href') || '').split('?')[0];
        links[i].setAttribute('href', base + '?variant=' + vid);
      }
    }
    if (wrap) {
      var all = wrap.querySelectorAll('.card-swatch-btn');
      for (var j = 0; j < all.length; j++) all[j].classList.remove('is-active');
    }
    btn.classList.add('is-active');
  }, true); // capture phase: intercept before the card's link fires
})();
